import * as React from "react";
import {useIsFetching} from "react-query";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const MWProgress = () => {
  // const isFetching = useIsFetching();
  // return isFetching ? (
  return (
    <Box sx={{position: "relative"}}>
      <Box
        sx={{
          zIndex: 1000,
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0,0,0,0.2)",
        }}
      >
        <CircularProgress size={120} />
      </Box>
    </Box>
  );
  // ) : null;
};

export default MWProgress;
